import { render, staticRenderFns } from "./PrivateForm.vue?vue&type=template&id=584f3c8e&scoped=true"
import script from "./PrivateForm.vue?vue&type=script&lang=js"
export * from "./PrivateForm.vue?vue&type=script&lang=js"
import style0 from "./PrivateForm.vue?vue&type=style&index=0&id=584f3c8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f3c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584f3c8e')) {
      api.createRecord('584f3c8e', component.options)
    } else {
      api.reload('584f3c8e', component.options)
    }
    module.hot.accept("./PrivateForm.vue?vue&type=template&id=584f3c8e&scoped=true", function () {
      api.rerender('584f3c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/user/PrivateForm.vue"
export default component.exports